var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtcSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 22,
    viewBox: "0 0 10 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.952026 16V5.64001H5.74003C6.41203 5.64001 6.9767 5.75668 7.43403 5.99001C7.9007 6.22334 8.25536 6.53601 8.49803 6.92801C8.7407 7.31068 8.86203 7.73534 8.86203 8.20201C8.86203 8.65934 8.77803 9.04202 8.61003 9.35002C8.44203 9.64868 8.2367 9.89135 7.99403 10.078C7.7607 10.2553 7.53203 10.3767 7.30803 10.442V10.554C7.56003 10.61 7.84003 10.7313 8.14803 10.918C8.45603 11.1047 8.72203 11.3707 8.94603 11.716C9.17003 12.0613 9.28203 12.5093 9.28203 13.06C9.28203 13.5453 9.16536 14.012 8.93203 14.46C8.70803 14.908 8.33936 15.2767 7.82603 15.566C7.32203 15.8553 6.66403 16 5.85203 16H0.952026ZM5.37603 7.44601H3.10803V9.85401H5.37603C5.86136 9.85401 6.21603 9.73734 6.44003 9.50401C6.66403 9.27068 6.77603 8.98601 6.77603 8.65001C6.77603 8.32334 6.66403 8.04334 6.44003 7.81001C6.21603 7.56734 5.86136 7.44601 5.37603 7.44601ZM5.54403 11.506H3.10803V14.194H5.54403C6.0947 14.194 6.49136 14.0633 6.73403 13.802C6.98603 13.5313 7.11203 13.2093 7.11203 12.836C7.11203 12.472 6.98603 12.1593 6.73403 11.898C6.49136 11.6367 6.0947 11.506 5.54403 11.506Z",
    fill: "#D4D4D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 4.25H2V6.25H3.5V4.25Z",
    fill: "#D4D4D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 4.25H4.5V6.25H6V4.25Z",
    fill: "#D4D4D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 15.25H2V17.25H3.5V15.25Z",
    fill: "#D4D4D8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15.25H4.5V17.25H6V15.25Z",
    fill: "#D4D4D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtcSymbol);
export default __webpack_public_path__ + "static/media/btcSymbol.371279d96472ac8a7b0392d000bf4868.svg";
export { ForwardRef as ReactComponent };